import styled from "styled-components";

export const ModalWrapper = styled.div`
    @media screen and (max-width: ${(props) => props.theme.mobileMenuBreakpoint}px) {
        font-size: 12px;
    }
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
`
export const ModalContent = styled.div`
    @media screen and (max-width: ${(props) => props.theme.mobileMenuBreakpoint}px) {
        height: 100%;
        width: 100%;
        padding: 40px;
        overflow: auto;
    }
    position: relative;
    width: 720px;
    border-radius: 20px;
    background-color: white;
    padding: 40px;
    display: flex;
    flex-direction: column;
`
export const ModalTitle = styled.h4`
    @media screen and (max-width: ${(props) => props.theme.mobileMenuBreakpoint}px) {
        margin-top: 40px;
        font-size: 16px;
    }
    margin: 0 0 60px 0;
    font-size: 24px;
    font-weight: 700;
    display: flex;
    justify-content: center;
`
export const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    position: relative;
`
export const ModalFooter = styled.div`
    display: flex;
    justify-content: center;
    @media screen and (max-width: 470px) {
        flex-direction: column;
    }
    @media screen and (max-width: 1000px) {
        margin-bottom: 80px;
    }
`
export const ModalSection = styled.div`
    padding-bottom: 30px;
`
export const ModalField = styled.div`
    display: block;
    margin-bottom: 10px;
`
export const ModalFieldTitle = styled.h4`
    @media screen and (max-width: 470px) {
        margin-bottom: 10px;
    }
    font-weight: 700;
    display: inline-block;
    margin: 0 10px 0 0;
    width: 180px;
`
export const ModalFieldSectionTitle = styled.h4`
    font-weight: 500;
    display: inline;
    margin-right: 10px;
    font-size: 18px;
`
export const ModalFieldValue = styled.span`
    @media screen and (max-width: 470px) {
        display: block;
    }
    display: inline;
`

export const ModalError = styled.p`
    display: inline;
    color: red;
    font-weight: 500;
`

export const ModalContentNewRole = styled.div`
    width: 500px;
    height: 250px;
    background-color: white;
    padding: 20px;
`
export const ProfileModalWrapper = styled.div`
    height: auto; 
    width: 282px;
    position: absolute;
    right: 10px;
    top: 105px;
    background: #FCFCFC;
    box-shadow: 0px 0px 8px rgb(0 0 0 / 25%);
    border-radius: 10px;
    &:after {
        position: absolute;
        content: '';
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid #fcfcfc;
        top: -19px;
        left: 84%;
        margin-left: -20px;
        border-top-right-radius: 50px;
        filter: drop-shadow(rgba(0, 0, 0, 0.15) 0.5px -1px 0px);
      }
`

export const ProfileModalContent = styled.div`
    padding: 20px 0px 20px 20px;
    display: grid;
    text-align-last: left;
`

export const ProfileLinkButton = styled.button`
    border: none;
    background-color: inherit;
    padding: 14px 0px 14px 0px;
    cursor: pointer;
    line-height: 18px;
`

export const ProfileModalName = styled.p`
    font-weight: bold;
    line-height: 18px;
    color: ${(props) => props.theme.brandColor1};
  `

export const LoadingContainer = styled.div`
    align-self: center;
    margin-top: -10px;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: #fefefe9e;
    display: flex;
`